// loadUrlQuery.js
'use strict';
import { replace } from '../action/navigationAction.js';
import loadUrlQueryRegion from '../action/loadUrlQueryRegion.js';
import loadUrlQueryUtm from '../action/loadUrlQueryUtm.js';
import loadUrlQueryAction from '../action/loadUrlQueryAction.js';
import loadUrlQueryRoute from '../action/loadUrlQueryRoute.js';
import loadCampaignFromUrlQuery from '../action/loadCampaignFromUrlQuery.js';
import getOperationData from '../selector/getOperationData.js';
import getRouterData from '../selector/getRouterData.js';
import { SET_OPERATION_DATA } from '../ActionTypes.js';
import { UiQueryWhiteList } from '../resource/feedConstants.js';

const selectPath = ['pendingRemoveSearchParam'];

/**
 * Load url query
 * @kind action
 * @param {URLSearchParams} {searchParams} - action param.
 * @return {Promise} Action promise.
 */
const loadUrlQuery =
  ({ searchParams }) =>
  async (dispatch, getState) => {
    // Remove redundant params to prevent trigger loadUrlQuery action again on page back
    if (searchParams.get('clear')) searchParams.delete('clear');

    // remove t param from `?t=TEMPLATE_ID` of oembed url
    if (searchParams.get('t')) searchParams.delete('t');

    // clean up the ui query
    const [uiQuery] = searchParams.getAll('ui');
    if (uiQuery && !UiQueryWhiteList[uiQuery]) searchParams.delete('ui');

    await Promise.all([
      dispatch(loadUrlQueryRegion({ searchParams })),
      dispatch(loadUrlQueryUtm({ searchParams })),
      dispatch(loadUrlQueryAction({ searchParams })),
      dispatch(loadUrlQueryRoute({ searchParams })),
      dispatch(loadCampaignFromUrlQuery({ searchParams })),
    ]);

    const pendingRemoveQuery =
      getOperationData(getState(), selectPath, 'query') || [];

    pendingRemoveQuery.forEach(queryKey => {
      searchParams.delete(queryKey);
    });
    const paramsString = searchParams.toString();
    const { pathname } = window.location;

    dispatch({
      type: SET_OPERATION_DATA,
      payload: {
        selectPath,
        data: {
          query: [],
        },
      },
    });

    const routerLocationState = getRouterData(getState(), [
      'location',
      'state',
    ]);
    return dispatch(
      replace(
        `${pathname}${paramsString ? '?' : ''}${decodeURIComponent(
          paramsString
        )}`,
        routerLocationState || history?.state
          ? {
              ...(history?.state || {}),
              ...(routerLocationState || {}),
            }
          : undefined
      )
    );
  };

export default loadUrlQuery;
